module.exports = __webpack_public_path__ + "media/throw-1.5fb8fa97.webm";